import { useShadow, useShadowStyle } from "../wcUtil.ts"
import styleText from './shared-modal-styles.css?raw';

export class AsModalRestoreSession extends HTMLElement {
  get html() {
    return /*html*/`
      <div class="panel-content">
        <as-text dict-key="apps.general.restore-session.title">Unsaved Session Found</as-text>
        <as-text dict-key="apps.general.restore-session.body">You have an unsaved session from a previous visit. Would you like to restore it or start fresh?</as-text>
        <div class="row option-buttons">
          <as-text-button name="discard-unsaved-session">Start New</as-text-button>
          <as-text-button name="restore-unsaved-session">Restore</as-text-button>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
  }
}

if (!customElements.get('as-modal-restore-session')) {
  customElements.define('as-modal-restore-session', AsModalRestoreSession);
} else {
  console.warn('as-modal-restore-session already defined');
}
